import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { Button, Modal, Fade, InputBase } from '@material-ui/core';

import { ModalContents, ModalTitle } from '../Common';
import images from '../../assets';
import { InputErrMsg, InputGroup, InputPad, inputStyle } from './login';

import Store from 'store'
import validatePassword from '../../_utils/password';
import apiClient from '../../_utils/axios';
import  { getModalWidh } from '../../_utils/modalWidh';
import store from '../../store';


export const FieldLabel = styled.div`
  font-family: 'NSCJKrM';
  font-size: 16px;
  color: black;
  line-height: 16px;
`;

export const CheckDuplicate = styled.div`
  cursor: pointer;
  background-color: #ff8a06;
  width: 80px;
  height: 32px;
  color: white;
  font-family: 'NSCJKrR';
  font-size: 14px;
  line-height: 32px;
  text-align: center;
`;

export const Essential = () => {
  return <span style={{ color: 'red' }}>*</span>;
};
export const WhiteEssential = () => {
  return <span style={{ color: 'white' }}>*</span>;
};

const Pointer = styled.div`
  cursor: pointer;
`;

export const RightFollow = ({ ...props }) => {
  return (
    <Pointer {...props}>
      <img alt="" src={images.gnb_submenu} style={{ height: 13, width: 'auto' }} />
    </Pointer>
  );
};

export const DesText = styled.div`
  font-family: 'NSCJKrR';
  font-size: 18px;
  color: black;
  /* line-height: 18px; */
`;

export const ButtonWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;

  Button {
    background-color: #ff8a06;
    color: #ffffff;

    &:disabled {
      background-color: #ff8a0650;
      color: #ffffff;
    }

    &:hover {
      background-color: #ff8a06;
    }
  }
`;


export const PasswordChangeModal = ({ show, onClose }) => {

  const { t } = useTranslation();
  const initialPasswordForm = {password: '', passwordRepeat: ''}
  const [passwordForm, setPasswordForm] = useState(initialPasswordForm)
  const [isFormValid, setIsFormValid] = useState(false) // true 일때 validation 통과
  const [validationMessage, setValidationMessage] = useState({
    kr: {
      invalidPassword: '비밀번호 형식이 올바르지 않습니다.',
      passwordNotSame: '비밀번호가 다릅니다. 다시 확인하세요.'
    },
    en: {
      invalidPassword: 'Invalid password format.',
      passwordNotSame: 'Your password is incorrect. Please check again.'
    }
  })

  useEffect(() => {
    const isPasswordValid = validatePassword(passwordForm.password)
    const isRepeatCheck = passwordForm.password === passwordForm.passwordRepeat

    setIsFormValid(isPasswordValid && isRepeatCheck)
  }, [passwordForm])

  const modalClose = (isRefresh = false) => {
    // 모달 닫을때 변수 초기화
    setPasswordForm(initialPasswordForm)
    setIsFormValid(false)
    onClose(isRefresh)
  }

  const submit = async () => {
    try {
      // TODO: 서버에서 사용자 정보 변경시 nickname 검증과정에서 에러가 발생
      // 차후 서버 코드 수정 후 nickname 보내는 부분 제거
      
      const nickname = store.getState().nickname
      const formData = {
        nickname,
        password: passwordForm.password,
      }
      const res = await apiClient.post('/web/edit/info', formData);

      if(!res?.data) return

      const resMessage = Store.get('lang') === 'kr' ? res.data.message_ko : res.data.message_en
      modalClose(true)
      alert(resMessage)
      
    } catch(error) {
      console.log('error: ', error);
    }

  }
  
  return (
    <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show} onClose={modalClose}>
      <Fade in={show}>
        <ModalContents style={{ width: getModalWidh() }} onClose={modalClose}>
          <ModalTitle>{t('change_password')}</ModalTitle>
          <InputGroup style={{ display: 'flex', alignItems: 'center' }}>
            <InputPad style={{ flex: 1 }}>
              <InputBase
                placeholder={t('password_detail')}
                inputProps={{ style: inputStyle }}
                style={{ width: '100%' }}
                type="password"
                onChange={(event) => setPasswordForm({...passwordForm, password: event.target.value})}
              />
            </InputPad>
          </InputGroup>
          <InputErrMsg>{
            passwordForm?.password?.length && !validatePassword(passwordForm.password) 
            ? Store.get('lang') === 'kr'
              ? validationMessage.kr.invalidPassword
              : validationMessage.en.invalidPassword
            : ''
          }</InputErrMsg>

          <InputGroup style={{ display: 'flex', alignItems: 'center' }}>
            <InputPad style={{ flex: 1 }}>
              <InputBase
                placeholder={t('enter_password_again')}
                inputProps={{ style: inputStyle }}
                style={{ width: '100%' }}
                type="password"
                onChange={(event) => setPasswordForm({...passwordForm, passwordRepeat: event.target.value})}
              />
            </InputPad>
          </InputGroup>
          <InputErrMsg>{
            !!passwordForm?.passwordRepeat?.length && passwordForm.password !== passwordForm.passwordRepeat
            ? Store.get('lang') === 'kr'
              ? validationMessage.kr.passwordNotSame
              : validationMessage.en.passwordNotSame
            : ''
          }</InputErrMsg>
          <ButtonWrapper>
            <Button 
              disabled={!isFormValid} 
              fullWidth 
              size='large'
              onClick={() => submit()}
            >
              {t('change_password')}
            </Button>
          </ButtonWrapper>
        </ModalContents>
      </Fade>
    </Modal>
  );
}